/* projects/speaker-platform/src/app/molecules/month-input/month-input.component.scss */
/*# sourceMappingURL=month-input.component-FDRZBGZH.css.map */
